import React from "react";
import PageHeader from "components/common/PageHeader";
import EmbeddedSymantecEDRApp from "./EmbeddedSymantecEDRApp";
const SymantecEDRApp = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: "Symantec EDR Integrations" }, /* @__PURE__ */ React.createElement("span", null, "This feature retrieves log records from Symantec EDR Platform.")), /* @__PURE__ */ React.createElement(EmbeddedSymantecEDRApp, null));
export default SymantecEDRApp;
